const OptionIcon = () => {
  return (
    <svg viewBox="0 0 3.111 14">
      <path
        d="M41.556,12a1.556,1.556,0,1,0,1.556,1.556A1.555,1.555,0,0,0,41.556,12Zm0,5.444A1.556,1.556,0,1,0,43.111,19,1.555,1.555,0,0,0,41.556,17.444Zm0,5.444a1.556,1.556,0,1,0,1.556,1.556A1.555,1.555,0,0,0,41.556,22.889Z"
        transform="translate(-40 -12)"
      />
    </svg>
  );
};

export default OptionIcon;
